import React from 'react';
import { Line } from 'recharts';

interface TumVersiyonlarLineProps {
  hidden: boolean;
}

export const TumVersiyonlarLine: React.FC<TumVersiyonlarLineProps> = ({ hidden }) => (
  <Line
    type="monotone"
    dataKey="Tüm Versiyonlar"
    stroke="#9ca3af"
    strokeWidth={2}
    strokeDasharray="5 5"
    dot={(props: { cx?: number; cy?: number; payload?: Record<string, unknown> }) => {
      const value = props.payload?.['Tüm Versiyonlar'] as number | undefined;
      if (value === undefined || value === null || value === 0) {
        return <circle cx={props.cx} cy={props.cy} r={0} fill="transparent" />;
      }
      return <circle cx={props.cx} cy={props.cy} r={3} fill="#9ca3af" />;
    }}
    activeDot={(props: { cx?: number; cy?: number; payload?: Record<string, unknown> }) => {
      const value = props.payload?.['Tüm Versiyonlar'] as number | undefined;
      if (value === undefined || value === null || value === 0) {
        return null;
      }
      return <circle cx={props.cx} cy={props.cy} r={5} fill="#9ca3af" />;
    }}
    name="Tüm Versiyonlar"
    hide={hidden}
    strokeOpacity={hidden ? 0 : 1}
    connectNulls={false}
    isAnimationActive={false}
  />
);
